import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import TaxCalculator from './TaxCalculator';

const VALID = ['US', 'UK', 'CA', 'DE', 'KSA', 'UAE'];

// Chrome-free calculator meant to be loaded inside a third-party <iframe>.
// Not indexed (noindex) to avoid duplicate-content — the full pages under /tools/* rank.
export default function EmbedCalculator() {
  const [params] = useSearchParams();
  const raw = (params.get('region') || 'US').toUpperCase();
  const initialRegion = VALID.includes(raw) ? raw : 'US';

  return (
    <div className="min-h-screen bg-white p-4 sm:p-6" data-testid="embed-calculator-page">
      <Helmet>
        <meta name="robots" content="noindex, follow" />
        <title>Free Tax Calculator — MoneyFeed</title>
      </Helmet>
      <div className="max-w-2xl mx-auto">
        <TaxCalculator initialRegion={initialRegion} embedded widget />
      </div>
    </div>
  );
}
